export const PROVINCES = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
  "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
  "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
  "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
  "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
  "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
  "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
  "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop",
  "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van",
  "Yalova", "Yozgat", "Zonguldak",
];

export const LISTING_TYPES = [
  "Satılık", "Aranıyor", "Kiralık", "Devren", "Hizmet", "Takas", "Toplu Satış", "Sürü Satışı",
  "Sabit Fiyat", "Pazarlığa Açık", "Teklif Usulü", "Rezervasyon", "Kurumsal Alım Talebi",
];

export const PRICE_TYPES = ["Sabit Fiyat", "Pazarlığa Açık", "Teklif Usulü"];

export const USER_ROLES = [
  { value: "IndividualUser", label: "Bireysel Kullanıcı" },
  { value: "Farmer", label: "Çiftçi" },
  { value: "FarmOwner", label: "Çiftlik Sahibi" },
  { value: "ProfessionalSeller", label: "Profesyonel Satıcı" },
  { value: "CorporateUser", label: "Kurumsal Kullanıcı" },
  { value: "Veterinarian", label: "Veteriner" },
  { value: "ServiceProvider", label: "Hizmet Sağlayıcı" },
  { value: "Transporter", label: "Nakliyeci" },
];

export const ROLE_LABELS = {
  IndividualUser: "Bireysel", Farmer: "Çiftçi", FarmOwner: "Çiftlik Sahibi",
  ProfessionalSeller: "Profesyonel Satıcı", CorporateUser: "Kurumsal", Veterinarian: "Veteriner",
  ServiceProvider: "Hizmet Sağlayıcı", Transporter: "Nakliyeci", Moderator: "Moderatör",
  SupportAgent: "Destek", Admin: "Yönetici", SuperAdmin: "Süper Yönetici",
};

export const VERIFICATION_LABELS = {
  phone: "Telefon Doğrulandı",
  email: "E-posta Doğrulandı",
  identity: "Kimlik Doğrulandı",
  business: "İşletme Bilgileri Doğrulandı",
  corporate: "Kurumsal Hesap",
  professional: "Profesyonel Satıcı",
};

export const STATUS_LABELS = {
  DRAFT: "Taslak", PENDING_REVIEW: "Onay Bekliyor", AUTOMATED_CHECK: "Otomatik Kontrol",
  MODERATOR_REVIEW: "Moderatör İncelemesinde", CHANGES_REQUESTED: "Düzeltme Bekliyor",
  DOCUMENT_REQUESTED: "Belge Bekliyor", APPROVED: "Onaylandı", PUBLISHED: "Yayında",
  REJECTED: "Reddedildi", PAUSED: "Duraklatıldı", RESERVED: "Rezerve", SOLD: "Satıldı",
  EXPIRED: "Süresi Doldu", UNDER_COMPLAINT_REVIEW: "Şikâyet İncelemesinde", ARCHIVED: "Arşivlendi",
};

export const STATUS_TONES = {
  PUBLISHED: "bg-secondary text-secondary-foreground",
  PENDING_REVIEW: "bg-accent text-accent-foreground",
  MODERATOR_REVIEW: "bg-accent text-accent-foreground",
  AUTOMATED_CHECK: "bg-accent text-accent-foreground",
  CHANGES_REQUESTED: "bg-[#B4531A] text-white",
  DOCUMENT_REQUESTED: "bg-[#B4531A] text-white",
  REJECTED: "bg-destructive text-destructive-foreground",
  UNDER_COMPLAINT_REVIEW: "bg-destructive text-destructive-foreground",
  SOLD: "bg-primary text-primary-foreground",
  RESERVED: "bg-primary text-primary-foreground",
  DRAFT: "bg-muted text-muted-foreground",
  PAUSED: "bg-muted text-muted-foreground",
  EXPIRED: "bg-muted text-muted-foreground",
  ARCHIVED: "bg-muted text-muted-foreground",
  APPROVED: "bg-secondary text-secondary-foreground",
};

export const OFFER_STATUS_LABELS = {
  PENDING: "Beklemede", ACCEPTED: "Kabul Edildi", REJECTED: "Reddedildi",
  COUNTERED: "Karşı Teklif", CANCELLED: "İptal Edildi", EXPIRED: "Süresi Doldu",
};

export const COMPLAINT_TYPES = [
  "Sahte ilan", "Dolandırıcılık", "Yanıltıcı fiyat", "Yanlış bilgi", "Çalıntı görsel",
  "Sahte belge", "Spam", "Taciz", "Hayvan refahı", "Diğer",
];

export const SORT_OPTIONS = [
  { value: "newest", label: "En Yeni" },
  { value: "price_asc", label: "Fiyat Artan" },
  { value: "price_desc", label: "Fiyat Azalan" },
  { value: "most_viewed", label: "En Çok Görüntülenen" },
  { value: "featured", label: "Öne Çıkan" },
  { value: "nearby", label: "Yakınımdaki" },
];

export const SEXES = ["Erkek", "Dişi"];
export const VACCINATION = ["Tam", "Kısmi", "Yok"];
export const REARING = ["Ahır", "Ağıl", "Mera", "Karma", "Kümes"];
export const BREEDING_STATUS = ["Damızlık", "Besilik", "Süt", "Kesimlik"];
